import React from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

export default function FooterSmall() {

    return (
        <>
            <Row className="footer-privacy footer-small">
                <Col sm={12}>
                    <a href="https://www.kawasaki.com/en-us/about/legal-policies" target="_blank" rel="noreferrer">Your Privacy Rights</a>
                    <a href="https://www.kawasaki.com/en-us/about/legal-policies#caPrivacyRights" target="_blank" rel="noreferrer">CA Privacy Rights</a>
                    <a href="https://www.kawasaki.com/en-us/about/legal-policies#termsConditionsUse" target="_blank" rel="noreferrer">Terms of Use</a>
                </Col>
            </Row>
        </>
    )
}